module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/e1c1595f09bbd039f7cabfe275e12a5f.png";